import axios from 'axios';
import qs from 'qs';
import { Loading, MessageBox } from 'element-ui';
import util from './util';
let requestNum = 0;
let loadingInstance;

const newAxios = axios.create({
  withCredentials: true,
  timeout: 450000
});

newAxios.interceptors.request.use(function(config) {
  requestNum++;
  loadingInstance = Loading.service({
    target: document.querySelector('.layout-container'),
    text: '加载中...'
  });
  return config;
});

// 拦截相应
newAxios.interceptors.response.use(
  function(config) {
    requestNum--;
    if (requestNum === 0) {
      loadingInstance.close();
    }
    return config;
  },
  function(err) {
    return Promise.reject(err);
  }
);

function getApiUrl(url, host = 'gagcheck') {
  const isDev = process.env.NODE_ENV === 'development';
  if (isDev) {
    return `/requestApi/${url}`;
  } else {
    const index = window.location.host.indexOf('.');
    const domain = window.location.host.substring(index);
    return `http://${host}${domain}/${url}`;
  }
}

export default ({ url, data, method, isFileRequest }) => {
  const requestPrams = {
    url: getApiUrl(url),
    method: method || 'post'
  };
  const token = util.getSessionStorage('login_token');

  if (token) {
    newAxios.defaults.headers.gagauthtoken = token;
  } else {
    delete newAxios.defaults.headers.gagauthtoken;
  }
  if (isFileRequest) {
    newAxios.defaults.headers['Content-Type'] = 'multipart/form-data';
    requestPrams.data = data;
  } else {
    newAxios.defaults.headers['Content-Type'] =
      'application/x-www-form-urlencoded';
    if (requestPrams.method === 'post') {
      requestPrams.data = qs.stringify(data);
    } else {
      requestPrams.params = data;
    }
  }

  return new Promise((resolve, reject) => {
    newAxios(requestPrams)
      .then(res => {
        const resMsg = res.data;
        if (resMsg.status === 'T') {
          window.location.href = '/login';
        } else if (resMsg.status === 'F') {
          MessageBox({
            title: '提示',
            message: resMsg.msg
          });
        } else if (resMsg.status === 'S') {
          resolve(resMsg.data);
        }
      })
      .catch(() => {
        MessageBox({
          title: '提示',
          message: '请求失败请重试'
        });
        loadingInstance.close();
      });
  });
};

export const blobFileRequest = ({ url, data, method, isPdfView }) => {
  const requestPrams = {
    url: getApiUrl(url),
    method: method || 'post',
    responseType: 'blob'
  };
  const token = util.getSessionStorage('login_token');
  if (token) {
    axios.defaults.headers.gagauthtoken = token;
  } else {
    delete axios.defaults.headers.gagauthtoken;
  }
  if (requestPrams.method === 'post') {
    requestPrams.data = qs.stringify(data);
  } else {
    requestPrams.params = data;
  }

  return new Promise((resolve, reject) => {
    axios(requestPrams)
      .then(res => {
        if (isPdfView) {
          if (res.data.size === 0) {
            MessageBox({
              title: '提示',
              message: '没有对应的pdf'
            });
          } else {
            const url = window.URL.createObjectURL(
              new Blob([res.data], { type: 'application/pdf;charset=utf-8' })
            );
            window.open(
              '/pdfjs/web/viewer.html?file=' + encodeURIComponent(url)
            );
          }
        } else {
          resolve(res.data);
        }
      })
      .catch(e => {
        console.error(e);
      });
  });
};

export const downloadRequest = ({ url, data, method, downloadFilename }) => {
  const requestPrams = {
    url: getApiUrl(url),
    method: method || 'post',
    responseType: 'blob'
  };
  const token = util.getSessionStorage('login_token');
  if (token) {
    axios.defaults.headers.gagauthtoken = token;
  } else {
    delete axios.defaults.headers.gagauthtoken;
  }
  if (requestPrams.method === 'post') {
    requestPrams.data = qs.stringify(data);
  } else {
    requestPrams.params = data;
  }
  axios(requestPrams)
    .then(res => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', downloadFilename || '文件');
      document.body.appendChild(link);
      link.click();
    })
    .catch(e => {
      console.error(e);
    });
};
